import "~/misc/common";
import DeviceBase from "./device_base";
import { GaugeTemperature } from "./gauge_temperature";
import { TimepickerOptions, TimepickerUI } from "timepicker-ui";
import "timepicker-ui/main.css";

export default class extends DeviceBase {
	connect() {
		const controller = this;
		this.connectBase({
			channel: "DeviceIfChannel",
			onConnection: (connected) => {
				if (connected) controller.sendCmd('?');
			},
			onEvent: (msg: string) => {
				if (msg.startsWith('temp.')) {
					temperature(msg.replace('temp.', ''));
				}
				if (msg.startsWith('fan=')) {
					fan(msg.replace('fan=', ''));
				}
				if (msg.startsWith('pwm.max=')) {
					$('#state_pwm_max').val(parseInt(msg.replace('pwm.max=', '')));
				}
				if (msg.startsWith('pwm.percent=')) {
					$('#state_pwm_percent').val(parseInt(msg.replace('pwm.percent=', '')));
				}
				if (msg.startsWith('temp.max=')) {
					$('#state_temp_max').val(parseInt(msg.replace('temp.max=', '')) / 10000.0);
				}
				if (msg.startsWith('ramp.time=')) {
					$('#state_ramp_time').val(parseInt(msg.replace('ramp.time=', '')));
				}
				if (msg.startsWith('time.on=')) {
					startClock.setValue(getClock(parseInt(msg.replace('time.on=', ''))));
				}
				if (msg.startsWith('time.off=')) {
					endClock.setValue(getClock(parseInt(msg.replace('time.off=', ''))));
				}
			}
		});

		const config: Partial<TimepickerOptions> = {
			clock: {
				type: '24h',
				incrementMinutes: 5,
				autoSwitchToMinutes: true
			},
			labels: {
				time: 'Válassz időpontot',
				cancel: 'Mégse'
			},
			behavior: {
				delayHandler: 20
			}
		};
		const startClock = new TimepickerUI("#state_start_clock", config);
		startClock.create();
		const endClock = new TimepickerUI("#state_end_clock", config);
		endClock.create();

		function getClock(sec: number) {
			return ('0' + Math.floor(sec / 3600)).slice(-2) + ':' + ('0' + (Math.floor(sec / 60) % 60)).slice(-2);
		}

		$('#fan').lc_switch('HŰT', 'ÁLL');

		const el = this.element as HTMLDivElement;
		const thermometers = JSON.parse(el.dataset.thermometers!);
		console.log(thermometers);

		$('#state_pwm_max').on('change', function () {
			controller.sendCmd('pwm.max=' + $('#state_pwm_max').myGetNumValue());
		});

		$('#state_temp_max').on('change', function () {
			controller.sendCmd('temp.max=' + Math.round($('#state_temp_max').myGetNumValue()! * 10000.0));
		});

		$('#state_ramp_time').on('change', function () {
			controller.sendCmd('ramp.time=' + $('#state_ramp_time').myGetNumValue());
		});

		$('#btn_on').on('click', function () {
			controller.sendCmd('ramp.state=1');
		});

		$('#btn_off').on('click', function () {
			controller.sendCmd('ramp.state=2');
		});

		startClock.on('confirm', (data) => {
			if (data.hour && data.minutes) {
				const sec = Number(data.hour) * 60 * 60 + Number(data.minutes) * 60;
				controller.sendCmd('time.on=' + sec);
			}
		});

		endClock.on('confirm', (data) => {
			if (data.hour && data.minutes) {
				const sec = Number(data.hour) * 60 * 60 + Number(data.minutes) * 60;
				controller.sendCmd('time.off=' + sec);
			}
		});

		function temperature(msg: string) {
			const parts = msg.split("=");
			const temp = parseFloat(parts[1]) / 10.0;
			const mac = parts[0];
			gauges.updateGauge(mac, temp);
		}

		function fan(msg: string) {
			msg == '1' ? $('#state_fan').lcs_on() : $('#state_fan').lcs_off();
		}

		// TEMPERATURE GAUGE
		const gauges = new GaugeTemperature(thermometers);
		gauges.options.majorTicks = ["10", "15", "20", "25", "30", "35", "40"];
		gauges.options.min = 10;
		gauges.options.max = 40;
		gauges.options.redFrom = 30;
		gauges.options.redTo = 40;

	}
}
